/**
 * Универсальный обработчик события cart:updated
 * Обновляет все компоненты корзины (счетчики, мини-корзина, хедер)
 */
(function() {
  'use strict';

  /**
   * Обновляет счетчик корзины в хедере и других местах
   */
  function updateCartCounters(cart) {
    const itemCount = cart.item_count || 0;

    // Обновляем все элементы с data-cart-count
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = itemCount;
      el.style.display = itemCount > 0 ? '' : 'none';
    });

    // Обновляем элементы с классом cart-count__text
    document.querySelectorAll('.cart-count__text, .chm-cart-count, .cart-indicator-fixed-count, .cart-indicator-fixed-text-count').forEach(el => {
      el.textContent = itemCount;
      // Добавляем анимацию пульса
      el.classList.remove('cart-indicator-pulse');
      void el.offsetWidth; // Trigger reflow
      el.classList.add('cart-indicator-pulse');
    });

    // Обновляем cart-bubble элементы
    document.querySelectorAll('.cart-bubble, .bottom-nav .cart-bubble').forEach(bubble => {
      const countEl = bubble.querySelector('.cart-bubble__text-count, .cart-bubble__count');
      if (countEl) {
        countEl.textContent = itemCount < 100 ? String(itemCount) : '99+';
      }
      bubble.style.display = itemCount > 0 ? 'grid' : 'none';
      bubble.classList.toggle('visually-hidden', itemCount === 0);
    });

    // Сохраняем в sessionStorage для других компонентов
    sessionStorage.setItem('cart-count', JSON.stringify({
      value: String(itemCount),
      timestamp: Date.now()
    }));

    // Обновляем глобальный кеш если есть
    if (window.cartCache && window.cartCache.set) {
      window.cartCache.set(cart);
    }
  }

  /**
   * Обновляет мини-корзину (drawer) если она есть
   */
  async function updateCartDrawer() {
    const drawer = document.querySelector('#CartDrawer, [id*="cart-drawer"], .cart-drawer');
    if (!drawer) return;

    try {
      // Пытаемся получить секцию корзины
      const sectionId = drawer.dataset.sectionId || 'cart-drawer';
      const response = await fetch(`/?section_id=${sectionId}`);
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector(`#${drawer.id}, [id*="cart-drawer"], .cart-drawer`);

      if (newDrawer) {
        drawer.replaceWith(newDrawer);
        // Инициализируем новый drawer если нужно
        if (window.initCartDrawer) {
          window.initCartDrawer();
        }
      }
    } catch (error) {
      console.error('Failed to update cart drawer:', error);
    }
  }

  /**
   * Обработчик события cart:updated
   */
  function handleCartUpdated(event) {
    const cart = event.detail?.cart || event.detail;
    
    if (!cart) {
      console.warn('cart:updated event received but no cart data');
      return;
    }

    // Обновляем счетчики синхронно
    updateCartCounters(cart);

    // Обновляем мини-корзину (асинхронно, не блокируем)
    updateCartDrawer().catch(() => {});

    // Вызываем кастомные обработчики если есть
    if (window.onCartUpdated && typeof window.onCartUpdated === 'function') {
      window.onCartUpdated(cart, event);
    }
  }

  // Слушаем новое событие
  document.addEventListener('cart:updated', handleCartUpdated);
  
  // Также слушаем старые события для обратной совместимости
  document.addEventListener('cart:update', (event) => {
    const cart = event.detail?.cart || event.detail;
    if (cart) {
      updateCartCounters(cart);
    }
  });
  
  document.addEventListener('shopify:cart:update', (event) => {
    const cart = event.detail?.cart || event.detail;
    if (cart) {
      updateCartCounters(cart);
    }
  });

  /**
   * Инициализация: загружаем корзину при загрузке страницы
   */
  async function init() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCartCounters(cart);
    } catch (error) {
      console.error('Failed to load cart on init:', error);
    }
  }

  // Инициализируем при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

